import axios from "axios";
import { requestMiddleware } from "../middlewares/requestMiddleware.js";

// const SITE_PREFIX = "https://178d71bcdf5f.ngrok.io/api"
const SITE_PREFIX = "https://privateapi.egalleria.in/api"
// const SITE_PREFIX = "http://127.0.0.1:8000/api"

export const actions = {

  // successfulRazorpaySubscription: (store, order_payment_data) =>
  //   new Promise((resolve, reject) => {
  //     var token = localStorage.getItem("token");
  //     axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  //     axios
  //       .post(SITE_PREFIX + `/payment/payment_success/`, order_payment_data)
  //       .then((res) => {
  //         requestMiddleware(res.data);
  //         resolve(res.data);
  //       })
  //       .catch((err) => reject(err));
  //   }),

  //   failedRazorpaySubscription: (store, order_payment_data) =>
  //   new Promise((resolve, reject) => {
  //     var token = localStorage.getItem("token");
  //     axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  //     axios
  //       .post(SITE_PREFIX + `/payment/payment_failed/`, order_payment_data)
  //       .then((res) => {
  //         requestMiddleware(res.data);
  //         resolve(res.data);
  //       })
  //       .catch((err) => reject(err));
  //   }),

  // SubscriptionPrePayment: (store, subscription_data) =>
  //   new Promise((resolve, reject) => {
  //     var token = localStorage.getItem("token");
  //     axios.defaults.headers.common["Authorization"] = `Token ${token}`;

  //     axios
  //       .post(SITE_PREFIX + `/payment/subscriptionpre/`, subscription_data)
  //       .then((res) => {
  //         requestMiddleware(res.data);
  //         resolve(res.data);
  //       })
  //       .catch((err) => reject(err));
  //   }),
  // plans: (store) =>
  //   new Promise((resolve, reject) => {
  //     axios
  //       .get(SITE_PREFIX + `/payment/plans/`)
  //       .then((res) => {
  //         requestMiddleware(res.data);
  //         resolve(res.data);
  //       })
  //       .catch((err) => reject(err));
  //   }),
  //   currentPlan: (store) =>
  //   new Promise((resolve, reject) => {
  //     axios
  //       .get(SITE_PREFIX + `/payment/current_subscription/`)
  //       .then((res) => {
  //         requestMiddleware(res.data);
  //         resolve(res.data);
  //       })
  //       .catch((err) => reject(err));
  //   }),
  sendEnquiry: (store, enquiry_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/sendenquiry/`, enquiry_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  createNewCart: (store, new_cart_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/createnewcart/`, new_cart_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  saveProfilePicture: (store, formdata) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;
      axios
        .patch(SITE_PREFIX + `/auth/userprofileavatar/`, formdata)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  getOrder: (store) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .get(SITE_PREFIX + `/cart-order/order/?q=AO`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  getPastOrder: (store) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .get(SITE_PREFIX + `/cart-order/order/?q=PO`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getOrderItems: (store, order_id) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .get(SITE_PREFIX + `/cart-order/order/${order_id}`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  deleteFrame: (store, cart_item_id) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .delete(SITE_PREFIX + `/cart-order/deleteitemframe/${cart_item_id}/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  addOrEditFrame: (store, new_frame_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/addoreditnewframe/`, new_frame_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  receiveOrder: (store, cart_id) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .get(SITE_PREFIX + `/cart-order/recieve_order/?cart_id=${cart_id}`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  preCheckoutCheck: (store) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .get(SITE_PREFIX + "/cart-order/precheckoutcheck/")
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  processRazorpayOrder: (store, order_meta_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      let endpoint_string = `/cart-order/checkout_session/?shipping_address_id=${order_meta_data.shipping_address_id}`;
      if (order_meta_data.existing_order_id) {
        endpoint_string += `&existing_order_id=${order_meta_data.existing_order_id}`;
      }

      axios
        .get(SITE_PREFIX + endpoint_string)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  successfulRazorpayOrder: (store, order_payment_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/confirm_order/`, order_payment_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  failedRazorpayOrder: (store, order_payment_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/payment_failed/`, order_payment_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  unfreezeProducts: (store, order_id) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .get(SITE_PREFIX + `/cart-order/unfreeze-products/${order_id}/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  deleteAddress: (store, address_id) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .delete(SITE_PREFIX + `/cart-order/address/${address_id}/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getAddress: (store) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .get(SITE_PREFIX + "/cart-order/address/")
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  addAddress: (store, new_address_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + "/cart-order/address/", new_address_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  editAddress: (store, address_meta_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .patch(
          SITE_PREFIX + `/cart-order/address/${address_meta_data.address_id}/`,
          address_meta_data.address
        )
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  addCartItemSize: (store, new_size_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/addnewsize/`, new_size_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  updateCartItemSizeQuantity: (store, cart_item_size_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/edititemsize/`, cart_item_size_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  deleteCartItemSize: (store, size_id) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .delete(SITE_PREFIX + `/cart-order/deleteitemsize/${size_id}/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  // addCartItem: (store, add_cart_data) => new Promise((resolve, reject) => {
  //     var token = localStorage.getItem("token");
  //     axios.defaults.headers.common['Authorization'] = `Token ${token}`;

  //     axios.post(SITE_PREFIX + `/cart-order/addcartitem/`, add_cart_data)
  //     .then(res => {
  //         requestMiddleware(res.data)
  //         resolve(res.data)
  //     })
  //     .catch(err => reject(err))
  // }),

  editCartItem: (store, edit_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .post(SITE_PREFIX + `/cart-order/editcartitem/`, edit_data)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  deleteCartItem: (store, item_id) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .delete(SITE_PREFIX + `/cart-order/deletecartitem/${item_id}/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getFrames: (store) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + "/art/frame/")
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getCartData: (store) =>
    new Promise((resolve, reject) => {
      if (store.getters.getCartList) {
        var token = localStorage.getItem("token");
        axios.defaults.headers.common["Authorization"] = `Token ${token}`;

        axios
          .get(SITE_PREFIX + "/cart-order/cart/")
          .then((res) => {
            requestMiddleware(res.data);
            resolve(res.data);
          })
          .catch((err) => reject(err));
      } else {
        resolve(store.getters.getCartList);
      }
    }),

  addItemToCart: (store, item_meta_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      let endpoint_string = `/cart-order/addcartItem/?product_id=${item_meta_data.product_id}`;
      if (item_meta_data.frame_id) {
        endpoint_string += `&frame_id=${item_meta_data.frame_id}`;
      }

      axios
        .get(SITE_PREFIX + endpoint_string)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getExhibitions: (store, filter_string) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + `/exhibition/exhibition/?limit=16${filter_string}`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  //search exhibitions
  searchExhibitions: (store, search_meta_data) =>
    new Promise((resolve, reject) => {
      axios
        .get(
          SITE_PREFIX +
            `/exhibition/exhibition/?limit=16${search_meta_data.filter_string}&search=${search_meta_data.search_keyword}`
        )
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  // end
  getNextOrPreviousExhibitions: (store, next_exhibition_link) =>
    new Promise((resolve, reject) => {
      next_exhibition_link =
        next_exhibition_link.slice(0, 4) + "s" + next_exhibition_link.slice(4);

      axios
        .get(next_exhibition_link)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  threeDGallery: (store, url) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + url)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getNextOrPreviousthreeDGallery: (store, url) =>
    new Promise((resolve, reject) => {
      url = url.slice(0, 4) + "s" + url.slice(4);
      axios
        .get(url)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  registerUser: (store, signup_info) =>
    new Promise((resolve, reject) => {
      axios
        .post(SITE_PREFIX + `/auth/register/`, signup_info)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  registerArtist: (store, signup_info) =>
    new Promise((resolve, reject) => {
      axios
        .put(SITE_PREFIX + `/auth/register/`, signup_info)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  sendVerificationEmail: (store, email) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + `/auth/emailverification/?email=${email}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  loginUser: (store, login_info) =>
    new Promise((resolve, reject) => {
      axios
        .post(SITE_PREFIX + `/auth/login/`, login_info)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  logout: (store) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;
      axios
        .post(SITE_PREFIX + "/auth/logout/")
        .then((res) => {
          store.state.IsAuthenticated = false;
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getProfile: () =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;
      axios
        .get(SITE_PREFIX + `/auth/profile/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  editProfile: (store, profile_meta_data) =>
    new Promise((resolve, reject) => {
      var token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Token ${token}`;

      axios
        .patch(
          SITE_PREFIX + `/auth/edituserprofile/${profile_meta_data.id}/`,
          profile_meta_data
        )
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getArtists: (store, quersy_string) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + `/auth/artistprofileinfo/?${quersy_string}`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getNextOrPreviousArtists: (store, url) =>
    new Promise((resolve, reject) => {
      url = url.slice(0, 4) + "s" + url.slice(4);
      axios
        .get(url)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  searchArtists: (store, search_meta_data) =>
    new Promise((resolve, reject) => {
      axios
        .get(
          SITE_PREFIX +
            `/auth/artistprofileinfo/?${search_meta_data.filter_string}&search=${search_meta_data.search_keyword}`
        )
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getArtist: (store, artist_slug) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + `/auth/artistprofileinfo/${artist_slug}/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getProducts: (store, filter_string) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + `/art/productinfo/?limit=16${filter_string}`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  // search Product function
  searchProduct: (store, search_meta_data) =>
    new Promise((resolve, reject) => {
      axios
        .get(
          SITE_PREFIX +
            `/art/productinfo/?limit=16${search_meta_data.filter_string}&search=${search_meta_data.search_keyword}`
        )
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  // end
  getNextOrPreviousProducts: (store, next_products_link) =>
    new Promise((resolve, reject) => {
      next_products_link =
        next_products_link.slice(0, 4) + "s" + next_products_link.slice(4);

      axios
        .get(next_products_link)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getIndividualArtStory: (store, art_story_slug) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + `/art/artstory/${art_story_slug}/`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getArtStories: (store, filter_string) =>
    new Promise((resolve, reject) => {
      axios
        .get(SITE_PREFIX + `/art/artstory/?${filter_string}`)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  // search art story
  searchArtStories: (store, search_meta_data) =>
    new Promise((resolve, reject) => {
      axios
        .get(
          SITE_PREFIX +
            `/art/artstory/?${search_meta_data.filter_string}&search=${search_meta_data.search_keyword}`
        )
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),
  // end
  getNextOrPreviousArtStories: (store, next_stories_link) =>
    new Promise((resolve, reject) => {
      // next_stories_link = next_stories_link.slice(0, 4) + 's' + next_stories_link.slice(4, )

      axios
        .get(next_stories_link)
        .then((res) => {
          requestMiddleware(res.data);
          resolve(res.data);
        })
        .catch((err) => reject(err));
    }),

  getHomePageContent: (store) =>
    new Promise((resolve, reject) => {
      if (store.state.homePageContent == null) {
        axios
          .get(
            SITE_PREFIX +
              `/art/homepage/?featured_art_count=4&featured_artists_count=4&featured_exhibition_count=4`
          )
          .then((res) => {
            requestMiddleware(res.data);
            resolve(res.data);
          })
          .catch((err) => reject(err));
      } else {
        resolve("exists");
      }
    }),

  // subscribeToNewsLetter: (store, email) =>
  //   new Promise((resolve, reject) => {
  //     let json_data = {};
  //     json_data["subscriber_email"] = email;

  //     axios
  //       .post(SITE_PREFIX + `/auth/newsletter/`, json_data)
  //       .then((res) => {
  //         requestMiddleware(res.data);
  //         resolve(res.data);
  //       })
  //       .catch((err) => reject(err));
  //   }),

  // sendOTP: () => new Promise((resolve, reject) => {
  //     var token = localStorage.getItem("token");
  //     axios.defaults.headers.common['Authorization'] = `Token ${token}`;
  //     axios.get(SITE_PREFIX + `/auth/PhoneNumberVerification/`)
  //         .then(res => {
  //             requestMiddleware(res.data)
  //             resolve(res.data)
  //         })
  //         .catch(err => reject(err))
  // }),

  // sendEnteredOTP: (store, json_data) => new Promise((resolve, reject) => {
  //     var token = localStorage.getItem("token");
  //     axios.defaults.headers.common['Authorization'] = `Token ${token}`;
  //     axios.post(SITE_PREFIX + `/auth/PhoneNumberVerification/`, json_data)
  //         .then(res => {
  //             requestMiddleware(res.data)
  //             resolve(res.data)
  //         })
  //         .catch(err => reject(err))
  // }),
};
